import update from 'immutability-helper';
import qwPartners from '../common/clients/qwPartners';

const initialState = {};
const RECEIVE = 'approvals/RECEIVE';

export function loadApprovals() {
  return (dispatch) => {
    return qwPartners
      .get('/v1/approvals/me')
      .then((res) => res.data)
      .then((approvals) => {
        dispatch(receiveApprovals(approvals));
      });
  };
}

export function receiveApprovals(approvals) {
  return { type: RECEIVE, payload: approvals };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case RECEIVE: {
      return update(state, { $set: payload });
    }

    default:
      return state;
  }
}
